<template>
  <div class="notice">
    <div class="out-box">
      <div class="left-box">
        <div class="notice-title">通知公告</div>
        <div class="notice-table">
          <el-table :data="noticeList" highlight-current-row style="width: 100%;" :show-header="false" @row-click="clickUrl">
            <el-table-column prop="title" show-overflow-tooltip></el-table-column>
            <el-table-column prop="send_date" width="60" :formatter="showFormatter">
            </el-table-column>
          </el-table>
        </div>
      </div>
      <div class="right-box" style="position: relative;" v-if="noticeId">
        <div class="title">{{noticeDetail.title}}</div>
        <div class="time">{{noticeDetail.send_date}}</div>
        <div class="content" v-html="noticeDetail.content"></div>
        <div class="accessory" style="display: flex;position: absolute;bottom: 0;">
          <span class="tips">附件：</span>
          <div v-for="(item, index) in accessorys" :key="index">
            <a :href="item.path" download target="_blank">
              <i class="el-icon-download"></i>
            </a>
            <a :href="item.path" download target="_blank">{{ item.name }}</a>
          </div>
          <div v-if="accessorys.length == 0">无</div>
        </div>
      </div>
      <div class="right-box" v-else style="display:flex;align-items:center;justify-content:center;font-size:14px;color:#999;">请点击左侧通知公告查看详情</div>
    </div>
  </div>
</template>

<script>
import baseApi from "@/api/base";
import { getStorage } from "@/common/js/localstorage";

export default {
  name: "Notice",
  data() {
    return {
      schoolId: 0,
      noticeList: [],
      noticeDetail: {},
      accessorys: [],
      noticeId: this.$route.query.id
    }
  },
  created() {
    this.getSchoolId();
  },
  mounted() {
    this.getAllNotice();
    if (this.noticeId) {
      this.getNoticeDetail(this.noticeId);
    }
  },
  methods: {
    // 先判断是否登录，再判断区域用户还是学校用户，并设置school_id
    getSchoolId() {
      if (getStorage("user")) {
        let data = getStorage("user");
        if (data.area_type == 2) {
          this.schoolId = data.area_id;
        }
      } else {
        if (getStorage("school")) {
          this.schoolId = getStorage("school").org_id
          return
        }
        this.schoolId = 1;
      }
    },
    // 点击跳转
    clickUrl(row) {
      this.accessorys = [];//清空附件链接
      this.getNoticeDetail(row.id);
    },
    // 获取所有通知公告列表
    getAllNotice() {
      baseApi.getAllNotice(this.schoolId).then((response) => {
        if (response.data.status == 0) {
          this.noticeList = response.data.data.list;
        } else {
          this.$message({
            type: "error",
            message: response.data.info.detail
          });
        }
      });
    },
    // 查看通知公告详情
    getNoticeDetail(id) {
      this.noticeId = id;
      baseApi.getNoticeDetail(id).then((response) => {
        if (response.data.status == 0) {
          this.noticeDetail = response.data.data;
          // 附件
          let accessorys = response.data.data.file_list;
          for (let i = 0; i < accessorys.length; i++) {
            accessorys[i].path = window.staticsHost + accessorys[i].path;
          }
          this.accessorys = accessorys;
        } else {
          this.$message({
            type: "error",
            message: response.data.info.detail
          });
        }
      });
    },
    // 显示内容格式化
    showFormatter(row) {
      let time = row.send_date;
      return time.split(" ")[0].split("-")[1] + "-" + time.split(" ")[0].split("-")[2]
    }
  }
}
</script>

<style scoped lang="stylus">
.notice {
  width: 100%;
  min-height: calc(100vh - 144px);
  display: flex;
  justify-content: center;

  .out-box {
    width: 80%;
    min-width: 900px;
    margin-top: 92px;
    margin-bottom: 40px;
    display: flex;
    justify-content: space-between;

    .left-box {
      width: 25%;
      border-radius: 20px;
      overflow: hidden;
      background: #F8F8F8;

      .notice-title {
        height: 60px;
        width: 100%;
        background: #3F91E5;
        line-height: 60px;
        color: white;
        font-size: 20px;
      }

      .notice-table {
        padding: 10px 10px 20px 10px;
      }
    }

    .right-box {
      width: 73%;
      padding: 0 20px 40px 20px;
      box-sizing: border-box;

      .title {
        font-size: 24px;
        font-weight: bold;
      }

      .time {
        font-size: 14px;
        color: #999999;
        margin-top: 15px;
        margin-bottom: 15px;
      }

      .content {
        color: #666666;
        line-height: 2em;
        text-align: justify;

        /deep/ th {
          border: 1px solid #ccc;
          text-align: center;
          background-color: #f1f1f1;
          font-size: 14px;
          padding: 3px 5px;
        }

        /deep/ td {
          border: 1px solid #ccc;
          font-size: 14px;
          padding: 3px 5px;
        }
      }
    }
  }
}
</style>